// extracted by mini-css-extract-plugin
export default {"cardPage":"vcard_cardPage__QTCxX"};